import { connect } from 'react-redux';
import CreateOrderSidepanel from '../components/create-order-sidepanel';
import { createOrder } from './create-order-actions';

import {
  getScheduledItems,
} from './create-order-selectors';

const mapStateToProps = state => ({
  navContext: state.order.create.navContext,
  scheduledItems: getScheduledItems(state),
  isLoading: state.order.create.isLoadingOrder,
  error: state.order.create.error,
  isSubmitting: state.order.create.isSubmitting,
});

const mapDispatchToProps = { createOrder };

export default connect(mapStateToProps, mapDispatchToProps)(CreateOrderSidepanel);
